import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import AppHome from '../views/AppHome'
import Login from '../views/login'
import Estatiscas from '../views/estatisticas'
import Ajuste from '../views/Ajustes'
import faturamento from '../views/faturamento'
import ajustesFaturamento from '../components/faturamento/ajustes'
import pesquisas from '../views/linksUteis'
import { getToken } from '../store/auth'

Vue.use(VueRouter)

const routes = [
  {
    path: '*',
    redirect: '/login'
  },
  {
    path: '/',
    name: 'AppHome',
    component: AppHome,
    beforeEnter: function (to, from, next) {
      let token = getToken()
      // console.log(token)
      if (!token) {
        next('login')
        return
      }
      next()
    },
    children: [
      {
        path: '/',
        name: 'home',
        component: Home
      },
      {
        path: '/ajustes',
        name: 'ajustes',
        component: Ajuste
      },
      {
        path: '/estatisticas',
        name: 'estatisticas',
        component: Estatiscas
      },
      {
        path: '/faturamento',
        name: 'faturamento',
        component: faturamento
      },
      {
        path: '/ajustesFaturamento',
        name: 'ajustesFaturamento',
        component: ajustesFaturamento
      },
      {
        path: '/pesquisas',
        name: 'pesquisas',
        component: pesquisas
      }
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  }
]
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: routes
})
export default router
